var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBirthday(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#212B36;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.8,10.5c1.2,0,2.2-1,2.2-2.2c0-0.4-0.1-0.8-0.3-1.1L15.8,4l-1.9,3.2c-0.2,0.3-0.3,0.7-0.3,1.1 C13.6,9.6,14.6,10.5,15.8,10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.4,13.8h-5.5v-2.2h-2.2v2.2H9.3c-1.8,0-3.3,1.5-3.3,3.3v1.7c0,1.2,1,2.1,2.1,2.1c0.6,0,1.1-0.2,1.5-0.6 L12,18l2.3,2.3c0.8,0.8,2.2,0.8,3,0l2.3-2.3l2.3,2.3c0.4,0.4,0.9,0.6,1.5,0.6c1.2,0,2.1-1,2.1-2.1v-1.7 C25.6,15.3,24.2,13.8,22.4,13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.8,21.4l-1.2-1.2l-1.2,1.2c-1.4,1.4-3.9,1.4-5.3,0L12,20.3l-1.2,1.2c-0.7,0.7-1.6,1.1-2.7,1.1 c-0.8,0-1.5-0.3-2.1-0.7v5C6,27.5,6.5,28,7.1,28h17.5c0.6,0,1.1-0.5,1.1-1.1v-5c-0.6,0.4-1.3,0.7-2.1,0.7 C22.5,22.5,21.5,22.2,20.8,21.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirthday);
export default __webpack_public_path__ + "static/media/birthday.fc3bd29105d0757750412b3e7450b014.svg";
export { ForwardRef as ReactComponent };